import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import * as styles from './Auth.module.css';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `https://qrbutlernew.onrender.com/reset-password-confirm`,
      });

      if (error) throw error;
      
      setMessage('Check your email for the password reset link');
    } catch (error) {
      setError(error.message || 'An error occurred while sending the password reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authFormContainer}>
        <div className={styles.authHeader}>
          <h2>Reset Your Password</h2>
          <p>Enter your email to receive a password reset link</p>
        </div>
        
        <form onSubmit={handlePasswordReset} className={styles.authForm}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>
          
          {error && <div className={styles.authError}>{error}</div>}
          {message && <div className={styles.authSuccess}>{message}</div>}
          
          <button 
            type="submit" 
            className={styles.authButton}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          <div className={styles.authLinks}>
            <Link to="/login">Back to Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordReset;
